export default {
  requestFee: `[{authority}]
신청서가 승인되었습니다. '접수비' 입금후 납부완료 버튼을 클릭해주세요. 또한 '심사비'는 심사위원 배정시 청구됩니다.

※반드시 업체명으로 입금요망※

**업체명: {companyName}
**심사종류 : {type}
**접수비 : {fee}원 (VAT 포함) 
**입금계좌 : {account}{footer}`,
  judgePlanSend: '[{authority}]\n이메일로 {to} 심사 계획서가 발송되었습니다.{footer}',
  judgeFee: {
    kcl: `[KCL_KS품질인증팀]
KS심사계획이 확정되어, 로그인후 심사계획서(심사수수료)를 확인해 주세요.
심사수수료는 '업체명'으로 입금을 부탁드립니다.
*입금계좌는 인증시스템 [마이페이지>My 심사현황] 또는 심사계획안내(이메일)에서 확인. 
심사원별 계좌가 상이한 경우 각각 계좌로 입금(주의)
*심사종류 : {type}
*접수비 미입금한 경우 금액 확인후 입금요망{footer}`,
    ktc: '[{authority}]\n심사계획이 확정되었습니다. 심사비 납부 후 납부완료 버튼을 클릭하시면 공장심사준비가 진행됩니다.\n**심사비 : {fee}원 (VAT 포함) \n입금계좌는 [마이페이지 > My 심사현황] 을 통해 확인하세요.{footer}',
    ktr: '[{authority}]\n심사계획이 확정되었습니다. 심사비 납부 후 납부완료 버튼을 클릭하시면 공장심사준비가 진행됩니다.\n**심사비 : {fee}원 (VAT 포함) \n입금계좌 :국민은행 373-01-0022-641 \n예 금 주 : (재)한국화학융합시험연구원{footer}',
    kilt: '[{authority}]\n심사계획이 확정되었습니다. 심사비 납부 후 납부완료 버튼을 클릭하시면 공장심사준비가 진행됩니다.\n**심사비 : {fee}원 (VAT 포함) \n입금계좌는 [마이페이지 > My 심사현황] 을 통해 확인하세요.{footer}',
    fiti: '[{authority}]\n심사계획이 확정되었습니다. 심사비 납부 후 납부완료 버튼을 클릭하시면 공장심사준비가 진행됩니다.\n**심사비 : {fee}원 (VAT 포함) \n입금계좌는 [마이페이지 > My 심사현황] 을 통해 확인하세요.{footer}',
  },
  committeeOpen: '[{authority}]\n{year}년 {no}차 인증위원회가 {openDate} {openTime}시 부터 시작됩니다. {footer}',
  improveReportRequest: '[{authority}]\n공장심사가 완료되었습니다.\n부적합개선조치를 하시고 개선조치보고서를 작성해주세요.\n[기한 {notFitDueDate}]\n심사원 연락처\n{judges} {footer}',
  improveRevokeRequest: '[{authority}]\n개선조치 보고서 보완이 필요합니다.\n사유를 확인하시고 개선조치보고서를 수정해주세요.\n심사원 연락처\n{judges} {footer}',
  requestReissueFee: '[{authority}]\n인증서({certNo}) 재발급/변경 신청이 승인되었습니다. 수수료 납부 후 납부완료 버튼을 클릭해주세요.\n**신청수수료 : 건당 {fee}원 VAT 포함 \n입금계좌 : {account} {return} {footer}',
  requestEngReissueFee: '[{authority}]\n영문인증서 신청이 승인되었습니다. 수수료 납부 후 납부완료 버튼을 클릭해주세요.\n**신청수수료 : {fee}원 VAT 포함 \n입금계좌 : {account} {footer}',
};



// WEBPACK FOOTER //
// ./src/data/msgs.js